var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccesos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_62_8",
    "data-name": "Componente 62 \\u2013 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "door_open_FILL0_wght300_GRAD0_opsz40",
    d: "M161.545-809.228a1.232,1.232,0,0,0,.911-.38,1.258,1.258,0,0,0,.375-.917,1.232,1.232,0,0,0-.38-.911,1.258,1.258,0,0,0-.916-.375,1.232,1.232,0,0,0-.911.38,1.258,1.258,0,0,0-.375.917,1.232,1.232,0,0,0,.38.911A1.258,1.258,0,0,0,161.545-809.228Zm-7.19,13.1v-2.127l11.357-1.589a.454.454,0,0,0,.334-.157.5.5,0,0,0,.138-.347v-19.417a2.067,2.067,0,0,0-.47-1.343,1.772,1.772,0,0,0-1.211-.665l-9.627-1.244v-2.11l10.034,1.4a3.765,3.765,0,0,1,2.438,1.31,3.87,3.87,0,0,1,.963,2.61v19.43a2.53,2.53,0,0,1-.656,1.724,2.591,2.591,0,0,1-1.635.882Zm0-2.127h17.755v-24.223a.507.507,0,0,0-.147-.374.507.507,0,0,0-.374-.147H154.876a.455.455,0,0,0-.374.129.507.507,0,0,0-.147.374Zm-4.059,2.127a1.027,1.027,0,0,1-.758-.307,1.037,1.037,0,0,1-.305-.762,1.02,1.02,0,0,1,.305-.757,1.036,1.036,0,0,1,.758-.3h1.932v-24.223a2.548,2.548,0,0,1,.78-1.868,2.548,2.548,0,0,1,1.868-.78H171.59a2.548,2.548,0,0,1,1.868.78,2.548,2.548,0,0,1,.78,1.868v24.223h1.932a1.027,1.027,0,0,1,.758.307,1.037,1.037,0,0,1,.305.762,1.02,1.02,0,0,1-.305.757,1.036,1.036,0,0,1-.758.3Z",
    transform: "translate(-147.232 827.125)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesos);
export default __webpack_public_path__ + "static/media/accesos.73c6515aadc78f1a1d30fe64b27451dd.svg";
export { ForwardRef as ReactComponent };